import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { uploadRecommendeds, getCsvRecommendedModel } from '../app/store/actions/recommended';
import UploadFilesComponent from '../components/upload';
import RecommendedImportErrors from '../components/upload/RecommendedImportErrors';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class UploadRecommendedsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
  }

  sendFile = async (file) => {
    await this.setState({ errors: {} });
    const result = await this.props.uploadRecommendeds(file);
    await this.setState({ errors: (result && result.errors) || [] });
  }

  modelDownload = async () => {
    await this.props.getCsvRecommendedModel();
  }

  goBack = () => {
    history.push(ROUTES.RECOMMENDED);
  }

  render() {
    const { errors } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">
          <h2><Translate value="importRecommendeds" /></h2>

          <div className="upload-text">
            <p><strong><Translate value="importText1" /></strong></p>
            <p><Translate value="importText2" /></p>
            <p><Translate value="importText3" /></p>
            <p><Translate value="importText4" /></p>
            <p><Translate value="recommendedImportText1" /></p>
            <p><Translate value="recommendedImportText2" /></p>
          </div>


          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            itemsErrors={<RecommendedImportErrors errors={errors} />}
          />

        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadRecommendeds: file => dispatch(uploadRecommendeds(file)),
  getCsvRecommendedModel: () => dispatch(getCsvRecommendedModel()),
});

export default connect(null, mapDispatchToProps)(UploadRecommendedsPage);
